import { useSearchParams } from 'react-router-dom';
import React, { useState } from 'react';
import { axiosInstance } from "../lib/axios.js";

function PasswordReset() {
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token');
    const email = searchParams.get('email');

    const [formData, setFormData] = useState({
        password: '',
        passwordConfirm: '',
    });

    const [passMatch, setPassMatch] = useState(true);
    const [submitted, setSubmitted] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData(prevState => {
            const newFormData = { ...prevState, [name]: value };

            // Проверка совпадения паролей после обновления состояния
            setPassMatch(newFormData.password === newFormData.passwordConfirm);
            return newFormData;
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        if (formData.password !== formData.passwordConfirm) {
            return;
        }

        if (!token || !email) {
            setError('Invalid reset link. Please request a new one.');
            return;
        }

        setLoading(true);

        try {
            await axiosInstance.post('/auth/reset-password', {
                token,
                email,
                password: formData.password
            });
            setSubmitted(true);
            setTimeout(() => { window.location.href = '/login'; }, 2000);
        } catch (err) {
            setError(err.response?.data?.error || 'Failed to reset password. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    const tipStyle = {
        display: passMatch ? 'none' : 'block',
        color: "#FF4F4F",
        textAlign: "left",
        fontSize: "12px"
    }


    return (
        <div className="page-login">

            <div className="wrapper">

                <h1>
                    New password
                </h1>

                <div className="form-block">

                    {submitted ? (
                        <div style={{ textAlign: 'center', padding: '20px 0' }}>
                            <div style={{ color: '#00CD5C', fontSize: '18px', marginBottom: '8px' }}>Password reset successful</div>
                            <div style={{ color: '#a0a0b0' }}>Redirecting to login...</div>
                        </div>
                    ) : (
                        <form onSubmit={handleSubmit}>
                            {error && (
                                <div style={{ color: '#FF4F4F', marginBottom: '16px', fontSize: '14px' }}>
                                    {error}
                                </div>
                            )}
                            <div className="form-group">
                                <label htmlFor="pass_1">New password</label>
                                <input
                                    id="pass_1"
                                    type="password"
                                    name="password"
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                            <div className="form-group">
                                <label htmlFor="pass_2">Confirm new password</label>
                                <input
                                    id="pass_2"
                                    type="password"
                                    name="passwordConfirm"
                                    onChange={handleChange}
                                    required
                                />
                                <div className="tip" style={tipStyle}>
                                    Passwords don't match
                                </div>
                            </div>

                            <button type="submit" className="submit-btn" disabled={loading || !passMatch}>
                                {loading ? 'RESETTING...' : 'SET NEW PASSWORD'}
                            </button>
                        </form>
                    )}

                </div>


            </div>

        </div>
    )
}

export {PasswordReset}
